<template>
  <div ref="dom" class="charts chart-bar"></div>
</template>

<script>
import { on, off } from "@/libs/tools";
var echarts = require("echarts");
export default {
  name: "ChartPie",
  props: {
    value: Array,
    text: String,
    subtext: String,
  },
  data() {
    return {
      dom: null,
    };
  },
  watch: {
    value: {
      handler(val) {
        // if (val.length) {
          console.log(val)
          this.loadEcharts(val);
        // }
      },
    },
  },
  methods: {
    resize() {
      this.dom.resize();
    },
    loadEcharts(val) {
      let xAxisData = [];
      let seriesData = [];
      val.forEach(item => {
        xAxisData.push(item.name);
        seriesData.push(item.value);
      })
      this.$nextTick(() => {
        let option = {
          color:['#52b9d3'],
          title: {
            text: this.text,
            subtext: this.subtext,
            left: "center",
            top:10
          },
          tooltip: {
            trigger: "item",
            formatter: this.text + "<br/>{b} : {c}",
          },
          legend: {
            type: "scroll",
            // orient: "vertical",
            right: 'center',
            // top: 20,
            bottom: '10%',
            // data: data.legendData,
          },
          xAxis: {
            type: 'category',
            data: xAxisData
          },
          yAxis: {
            type: 'value'
          },
          series: [{
            data: seriesData,
            type: 'bar'
          }]
        };
        this.dom = echarts.init(this.$refs.dom);
        this.dom.setOption(option);
        on(window, "resize", this.resize);
      });
    },
  },
  mounted() {this.loadEcharts(this.value);},
  beforeDestroy() {
    off(window, "resize", this.resize);
  },
};
</script>

